module.exports = __webpack_public_path__ + "img/rts_labeled.83b6d5f9.jpg";